/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CarefinityRoles } from '../../models/carefinity-roles';

export interface RolesEditRoles$Params {
  RoleId?: number;
      body: CarefinityRoles
}

export function rolesEditRoles(http: HttpClient, rootUrl: string, params: RolesEditRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, rolesEditRoles.PATH, 'put');
  if (params) {
    rb.query('RoleId', params.RoleId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

rolesEditRoles.PATH = '/roles/updateCarefinityroles';
